/**
 * List
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import DropdownLayer from '../DropdownLayer';
import GameInfo from '../GameInfo';
import ParamInfo from './ParamInfo';

class Search {

	public onResetSearch: any;

	private $parent: any;

	private callback: any;

	private _id: string;

	private _wrapId: string;

	private dropdownLayer: DropdownLayer;

    private paramInfo: any;

    private $resetButton: any;

    private _setTime: any;

	constructor( $parent: any, callback: any ) {
		this.$parent = $parent;
		this.callback = callback;
		this._id = 'ncCommunitySearch';
		this._wrapId = 'ncCommunitySearchType';
		this._setTime = null;
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		this.setCategoryUI();
		this.setSearchBox();

		this.$resetButton = this.$parent.find('.ui-input-box-search .co-btn-reset');

		this.addSearchEvent();

		this.onResetSearch = new Util.Observer();

		const _query = this.paramInfo.getParamByKey( 'query' );
		const _searchType = this.paramInfo.getParamByKey( 'searchType' );

		// lineage 서버지기
		if ( _query && _searchType !== 'tag' ) {
            this.$parent.addClass('is-show');
        }

		if ( !Config.isShowSearchForm  ) {
			jQuery( `#${this._wrapId}`).hide();
		}
    }

	public setCategoryUI() {
		const tmp: any = [];
		const title = 'title';
		const writer = 'writer';
		const hash = 'hash';
		const contents = 'title,contents';
		let searchTypes = [];

		if ( Config.searchTypes ) {
			searchTypes = Config.searchTypes;
		}

		if ( Config.isUsingSearchContents ) {
			searchTypes.push( {categoryId: contents, categoryName: Config.L10N.search_searchtype_content} );
		}

		if ( Config.isUsingSearchTitle ) {
			searchTypes.push( {categoryId: title, categoryName: Config.L10N.search_searchtype_title} );
		}

		if ( !Config.isAdmin && Config.isUsingSearchWriter ) {
			searchTypes.push( {categoryId: writer, categoryName: Config.L10N.search_searchtype_writer} );
		}

		if ( Config.isUsingSearchTag ) {
			searchTypes.push( {categoryId: hash, categoryName: Config.L10N.search_searchtype_tag} );
		}

		searchTypes.forEach( ( item: any ) => {
			tmp.push({
				key: item.categoryId,
				value: item.categoryName,
			});
		});

		this.dropdownLayer = new DropdownLayer( this.$parent, tmp, this._wrapId, 'board-search' );
		this.dropdownLayer.addChange( ( data = '' ) => {
			const query = this.getQuery();
			if ( query !== '' && data !== '' && this.callback ) {
				this.callback( query, data );
			}
		});

		if ( tmp[ 0 ] ) {
			this.dropdownLayer.setValue( tmp[ 0 ].key );
		}
	}

	public getSearchType() {
		return '' + this.dropdownLayer.getValue();
	}

	public setSearchType( val: string ) {
		this.dropdownLayer.setValue( val );
	}

	public setQuery( val: string ) {
		this.$parent.find( '#' + this._id ).val( val );
	}

	public getQuery() {
		return this.$parent.find( '#' + this._id ).val() || '';
	}

	public setSearchBox() {
		this.dropdownLayer.getNode().append( this.templateSearchBox() );
	}

	public setResultUI( count: string ) {
		const query = this.getQuery();
		if ( !query  ) {
			return '';
		}

		this.dropdownLayer.getNode().find('.ui-dropdown').addClass('is-show');

		return `<div class="board-search-result">
				<span class="title">${Config.L10N.search_result} </span><em class="count">${count}${Config.L10N.search_result_count}</em>
				<button class="co-btn btn-delete"><i class="fe-icon-close_circle_o"></i></button>
			</div>`;
	}

	private templateSearchBox() {
		return `<form class="ui-input-box ui-input-box-search" action="list" onsubmit="return false;">
                <input type="search" id="${this._id}" class="input-board-search" name="query" value="" placeholder="${Config.L10N.search_place_holder}" required autocomplete="off" aria-label="${Config.L10N.search_place_holder}">
                <button class="co-btn co-btn-reset" aria-label="취소" type="button"><i class="fe-icon-close_circle"></i></button>
                <button class="co-btn co-btn-clear" aria-label="검색어 초기화" type="button"></button>
			</form>`;
	}

    private hideResetButton() {
        const $resetButton = this.$parent.find('.ui-input-box-search .co-btn-reset');
        $resetButton.removeClass('is-show');
    }

	public addSearchEvent() {
		this.$parent.on( 'keypress', '#' + this._id , ( evt: any ) => {
			const key = evt.keyCode;

			if ( key === 13 ) {
				let type = this.getSearchType();
				let val = evt.target.value;
				// enterkey
				if ( val !== '' && type !== '' && this.callback ) {
					this.callback( val, type );
				}
			}
		});

		this.$parent.on('focus', '#' + this._id, ( evt: any ) => {
			evt.preventDefault();
			this.$parent.addClass('is-show');
		});

		this.$parent.on( 'click', '.ui-input-box-search .co-btn-reset', ( evt: any ) => {
            evt.preventDefault();
            jQuery(  '#' + this._id ).val( '' );
            this.hideResetButton();
		});

		this.$parent.on('click', '.ui-input-box-search .co-btn-clear', ( evt: any ) => {
            evt.preventDefault();
            jQuery(  '#' + this._id ).val( '' );
            this.$parent.removeClass('is-show');
            this.hideResetButton();
        });

		jQuery( 'body' ).on( 'click', '.btn-delete', ( evt ) => {
			this.onResetSearch.emit();
		});
	}
}

export default Search;
